import useSessionStorageService from './session';
import { resolvePathWithSavedParams } from './resolvePathWithSavedParams';

export function useWithSavedParams() {
  const { getSessionKeyData } = useSessionStorageService();

  return to => resolvePathWithSavedParams(to, getSessionKeyData);
}
